// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".feedback-overview {\n  font-size: 12px;\n  margin-bottom: 1em;\n}\n.feedback-overview span.label {\n  font-weight: bold;\n  margin-right: 1em;\n}\n.feedback-overview span.value {\n  font-weight: normal;\n  font-size: 1.1em;\n}\n", ""]);
// Exports
module.exports = exports;
